import { SharedMakeupsTable } from '@/components/shared/makeups-table';
import type { MakeupItem } from '@/components/shared/makeups-table';

interface MakeupsListProps {
  title: string;
  description: string;
  makeups: MakeupItem[];
  variant: 'pending' | 'scheduled' | 'history';
  onSchedule?: (makeupId: string) => void;
  onComplete?: (makeupId: string) => void;
  onWaive?: (makeupId: string) => void;
}

export function MakeupsList({
  title,
  description,
  makeups,
  variant,
  onSchedule,
  onComplete,
  onWaive,
}: MakeupsListProps) {
  return (
    <SharedMakeupsTable
      title={title}
      description={description}
      makeups={makeups}
      variant={variant}
      maxHistoryItems={variant === 'history' ? 10 : undefined}
      onSchedule={onSchedule}
      onComplete={onComplete}
      onWaive={onWaive}
    />
  );
}
